/**
 * Display languages. SUPPORTED_LANGUAGES is every code the account may store (the API accepts the same
 * list); TRANSLATED_LANGUAGES is the single list of languages with a complete translation, and the only
 * ones any picker offers or the app switches to. Today only English is complete, so the picker is hidden.
 * Adding a language here, once its locale file is whole, shows the pickers again. Locale files and a
 * stored preference are never deleted.
 */
export const SUPPORTED_LANGUAGES = ["en", "fr", "de", "es", "pt", "nl", "it", "pl", "sv", "da", "fi", "cs", "ro"] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const TRANSLATED_LANGUAGES: readonly SupportedLanguage[] = ["en"];

export const isFullyTranslated = (lang: string | null | undefined): lang is SupportedLanguage =>
  !!lang && (TRANSLATED_LANGUAGES as readonly string[]).includes(lang);

/** Whether a language choice means anything: more than one language is fully translated. */
export const languagePickerAvailable = (translated: readonly string[] = TRANSLATED_LANGUAGES): boolean => translated.length > 1;
